import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "input" ]

  submitResults(event) {
    this.element.requestSubmit();
  }

  tips(event) {
    let searchValue = event.target.innerText;
    let input = document.getElementById('ai_message_content');
    input.value = searchValue;
    input.form.requestSubmit();
  }
}

